var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container collection-slots-container"},[_c('global-header'),_c('collection-slot-body')],1)}
var staticRenderFns = []

export { render, staticRenderFns }